import axiosClient from "../axios/axiosClient";

export function getDashboardData(sessionId) {
  return axiosClient.get("/dashboard-data", {
    params: sessionId ? { session_id: sessionId } : {},
  });
}

export function getInstitutionDashboardData(sessionId) {
  return axiosClient.get("/institution-dashboard-data", {
    params: sessionId ? { session_id: sessionId } : {},
  });
}
